import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';

export const SDrawer = styled(Drawer)(() => ({
    '& .MuiPaper-root':{
        width: '100%',
        minWidth: 320,
        maxWidth: 320,
        background: 'rgba(9,88,73,.95)'
    }
}));

export const STitle = styled(Typography)(() => ({
    marginLeft: '1.2rem',
    color: '#FFF'
}));

export const SListItem = styled(ListItem)(() => ({
    paddingTop: 0,
    mpaddingBottom: 0,
    '& .MuiButtonBase-root': {
        marginLeft: '1.2rem',
        padding: 0,
        '& .MuiTypography-root': {
            color: '#FFF',
            fontSize: '1rem',
        }
    }
}));